import { companyRoutes } from './companies';
import { orderRoutes } from './orders';
import { opportunitySettingsRoutes } from './opportunities';
import { presalesSettingsRoutes } from './presales';
import { presalesTicketStagesSettingsRoutes } from './presales-ticket-stages';
import { presalesRequestTypesSettingsRoutes } from './presales-request-types';
import { presalesServiceTypesSettingsRoutes } from './presales-service-types';

export const accountRoutes = [
  {
    path: 'accounts',
    children: [
      ...companyRoutes,
      ...orderRoutes,
      ...opportunitySettingsRoutes,
      ...presalesSettingsRoutes,
      ...presalesTicketStagesSettingsRoutes,
      ...presalesRequestTypesSettingsRoutes,
      ...presalesServiceTypesSettingsRoutes,
    ],
  },
];
